import { render, staticRenderFns } from "./guest-list.vue?vue&type=template&id=a15a684c&scoped=true&"
import script from "./guest-list.vue?vue&type=script&lang=js&"
export * from "./guest-list.vue?vue&type=script&lang=js&"
import style0 from "./guest-list.vue?vue&type=style&index=0&id=a15a684c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15a684c",
  null
  
)

export default component.exports